export const sortStrings = (a, b) => {
    if (a == null && b == null) {
        return 0
    }
    if (a == null) {
        return -1
    }
    if (b == null) {
        return 1
    }

    return a.localeCompare(b, ['sv', 'dk', 'fi', 'en'], { sensitivity: 'case' })
}

export const sortNumbers = (a, b) => {
    if (a == null && b == null) {
        return 0
    }
    if (a == null) {
        return -1
    }
    if (b == null) {
        return 1
    }

    if (a < b) {
        return -1
    }
    if (a > b) {
        return 1
    }

    return 0
}

export const reverseSorter = (sorter) => (a, b) => sorter(b, a)

export const mapSort = (sorter, mapper) => (a, b) => {
    const am = mapper(a)
    const bm = mapper(b)
    return sorter(am, bm)
}
